export const environment = {
    production: true,
    apiUrl: 'https://colony-admin.transnetyx.com/api',

    auth0: {
        domain: 'login.transnetyx.com',
        clientId: 'i874OtIXhvoGoxoBzhRZ1YljxMyfrQMU',
        redirectUri: `${window.location.origin}`,
        logoutReturnUrl: `https://accounts.transnetyx.com/v2/logout/colony`,
        logoutUrl: 'https://login.transnetyx.com/v2/logout',
    },

    accountsUrl: 'https://accounts.transnetyx.com/',
    geneticMonitoring: 'https://quickorder.transnetyx.com/MVC/GeneticMonitoring',
    microbiome: 'https://quickorder.transnetyx.com/MVC/Microbiome',
    supportHubUrl: 'https://www.transnetyx.com/support',
    quickorder: 'https://quickorder.transnetyx.com/home',

    colonyNotificationsUrl: 'https://colony.transnetyx.com/Notifications',
    colonyOrdersCartUrl: 'https://colony.transnetyx.com/Orders/Cart',
    colonyUrlDashboard: 'https://colony.transnetyx.com',
    colonyUrlStrains: 'https://colony.transnetyx.com/Strains',
    colonyUrlGeneMutations: 'https://colony.transnetyx.com/Mutations',
    colonyUrlMice: 'https://colony.transnetyx.com/Mice/MiceList',
    colonyUrlBreedings: 'https://colony.transnetyx.com/Breedings',
    colonyUrlLitters: 'https://colony.transnetyx.com/Litters',
    colonyUrlCages: 'https://colony.transnetyx.com/Cage',
    colonyUrlCagesMapView: 'https://colony.transnetyx.com/Cage/Cages',
    colonyUrlCagesList: 'https://colony.transnetyx.com/Cage/CageList',
    colonyUrlCagesWorkbench: 'https://colony.transnetyx.com/Cage/Workbench',
    colonyUrlTasks: 'https://colony.transnetyx.com/Tasks',
    colonyUrlAmi: 'https://colony.transnetyx.com/Ami/Projects',
    colonyUrlAmiCalculator: 'https://colony.transnetyx.com/AmiCalculator',
    colonyUrlAdministrationUsers: 'https://colony.transnetyx.com/Admin/User',
    colonyUrlAdministrationGroups: 'https://colony.transnetyx.com/Admin/Group',
    colonyUrlAdministrationAuditLog: 'https://colony.transnetyx.com/Admin/AuditLogSearch',
    colonyUrlAdministrationMouseImport: 'https://colony.transnetyx.com/Mice/ImportAdmin',
    colonyUrlAdministrationReloadGroupData: 'https://colony.transnetyx.com/Admin/Group/ResetGroups',
    colonyUrlAdministrationBannerMaintenance: 'https://colony.transnetyx.com/Admin/Banner/Details',
    colonyUrlAdministrationScheduledJobs: 'https://colonyhangfire.azurewebsites.net/hangfire',
};
